import React, { useEffect, useState } from "react";

// Types
import { RegistrationStage } from "../../../types";

// Services
import { ApiService } from "../../../services";

// Components
import Form from "../../../pages/FormBuilder/Form";
import { Sidebar as AdminSidebar } from "../Sidebar";

interface Props {
  className?: string;
}

const Sidebar: React.FC<Props> = (props: Props) => {
  const [loading, setLoading]: [boolean, any] = useState(true);
  const [rawStages, setRawStages]: [any, any] = useState([]);
  const [stages, setStages]: [any, any] = useState([]);

  useEffect(() => {
    if (!loading) return;

    ApiService.get("register")
      .then((stages: RegistrationStage[]) => {
        // eslint-disable-next-line
        stages.map((stage) => {
          // eslint-disable-next-line
          if (stage.id === 2 || stage.id === 10) return;

          // @ts-ignore
          stage.form!.icon = stage.icon;
          stage.form!.visible = true;
          stage.form!.open = false;
        });

        setRawStages(stages);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const isNotComponentMount = rawStages.length > 0;
    isNotComponentMount && setStagesState(rawStages);
  }, [rawStages]);

  function setStagesState(stages: any) {
    setStages([
      {
        label: "1/ Register",
        visible: true,
        stageIds: [1],
        requiresReview: stages[0].requires_review,
        component: (
          <div className="form-list">
            <Form form={stages[0].form} type="basic" showFormOverview={false} />
          </div>
        ),
      },
    ]);
  }

  return <AdminSidebar tabs={stages} className={props.className} />;
};

export default Sidebar;
